import { createContext, useContext } from 'react';

// Standalone screens retain their existing behaviour outside the app gate.
export const CentralReadyContext = createContext(true);
export const useCentralReady = () => useContext(CentralReadyContext);

export const CentralRecoveryContext = createContext(false);
export const useCentralRecovery = () => useContext(CentralRecoveryContext);
